<template>
  <div>
    <rest-form-item :label="$t('ChannelConfig_Vonage_Key')" prop="key">
      <el-input
        v-model="model.params.key"
        :placeholder="$t('ChannelConfig_Vonage_Key_Placeholder')"
      />
    </rest-form-item>
    <rest-form-item :label="$t('ChannelConfig_Vonage_Secret')" prop="secret">
      <el-input
        v-model="model.params.secret"
        :placeholder="$t('ChannelConfig_Vonage_Secret_Placeholder')"
      />
    </rest-form-item>

    <div class="section-ct">
      <rest-form-item
        class="field-ct"
        :label="$t('ChannelConfig_Vonage_Rcs_Enable')"
        prop="rcs"
      >
        <el-switch
          class="switch"
          v-model="model.params.rcs"
          data-qa="enable-rcs"
          :active-value="true"
          :inactive-value="false"
        />
      </rest-form-item>
    </div>
    <rest-form-item
      v-if="model.params.rcs"
      :label="$t('ChannelConfig_Vonage_Rcs_ApplicationId')"
      prop="application_id"
    >
      <el-input
        v-model="model.params.application_id"
        data-qa="application-id"
      />
    </rest-form-item>
    <rest-form-item
      v-if="model.params.rcs"
      :label="$t('ChannelConfig_Vonage_Rcs_PrivateKey')"
      prop="private_key"
    >
      <el-input
        type="textarea"
        v-model="model.params.private_key"
        :rows="6"
        data-qa="private-key"
      />
    </rest-form-item>
  </div>
</template>

<script>
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  components: { RestFormItem },
  props: {
    model: {
      type: Object,
      required: true
    }
  },

  created() {
    if (!this.$route.query.id) {
      this.$set(this.model, 'type', 'sms')
      this.$set(this.model, 'channel', 'vonage')
      this.$set(this.model, 'params', {})
    }
    this.$emit('register-before-save-fn', this.beforeSave)
  },

  methods: {
    beforeSave() {
      if (this.model.params && !this.model.params.rcs) {
        delete this.model.params.application_id
        delete this.model.params.private_key
      }
    }
  }
}
</script>
<style scoped>
.field-ct {
  display: flex;
  align-self: center;
  column-gap: 15px;
  margin-left: -15px;
}
.switch {
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/modules/channels/providers/Vonage.vue